<template>
    <div id="container">
        <nav id="navbar">
            <div style="padding: 0 20px;">
                <a href=""><img height="30" src="https://referon.it/files/logo_dark_sm.png" alt=""></a>
            </div>
            <span v-if="store.admin.role !== 'SUPER'">{{ store.admin!.organization!.name }}</span>
            <div class="btn" @click="logout">
                <span style="color: white; display: flex; column-gap: 8px;"><b>Esci</b><font-awesome-icon
                        icon="power-off" /></span>
            </div>
        </nav>
        <main>
            <nav id="sidebar">
                <div class="list">
                    <a v-if="store.admin.role === 'SUPER'" :class="isCurrent('organizations')" @click="navigate('organizations')">Strutture</a>
                    <a :class="isCurrent('users')" @click="navigate('users')">Utenti</a>
                    <a v-if="store.admin.role !== 'SUPER'" :class="isCurrent('upload')" @click="navigate('upload')">Upload documento</a>
                </div>
            </nav>
            <div id="inner">
                <router-view />
            </div>
        </main>
    </div>
</template>

<script lang="ts">
import VueBase from "@/components/VueBase";
import { ElMessageBox } from "element-plus";
import {useMainStore} from "@/stores/mainStore";

export default class DashboardLayout extends VueBase {
    store = useMainStore();

    isCurrent(path: string) {
        return path === this.$route.name ? "current" : "";
    }

    navigate(path: string) {
        this.$router.push(path);
    }

    logout() {
        ElMessageBox.confirm("Sei sicuro di voler uscire?", {
            title: "Attenzione",
            cancelButtonText: "Annulla",
            confirmButtonText: "Esci"
        })
            .then(async () => {
                sessionStorage.removeItem("access-token");
                this.$router.push("login");
            })
            .catch(() => { });

    }
}
</script>

<style lang="scss" scoped>
#container {
    display: grid;
    grid-template-rows: 50px 1fr;
    height: 100%;
    overflow: hidden;
}

main {
    height: 100%;
    display: grid;
    grid-template-columns: 250px 1fr;
    overflow: hidden;
}

#inner {
    height: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    overflow-y: scroll;
}

#navbar {
    background-color: #5e589c;
    border-bottom: 1px solid #2d2963;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    color: white;

    & .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
        cursor: pointer;
        height: 100%;

        &:hover {
            background-color: #2d2963;
        }
    }
}

#sidebar {
    background-color: #eeeeee;
    border-right: 1px solid lightgray;

    .list {
        display: flex;
        flex-direction: column;

        a {
            text-decoration: none;
            color: inherit;
            padding: 20px;
            cursor: pointer;

            &.current {
                font-weight: bold;
                background-color: #dddddd;
                border-right: 5px solid #5e589c;
            }

            &:hover {
                background-color: #cccccc;
            }
        }
    }
}
</style>